<template>
  <LKRoadmapsFeedModalContainer
    v-if="isActive"
    content-class="LKPassportModal"
    @close="close"
  >
    <div style="padding: 0 1rem;">
      <PassportForm
        :data="data"
        closeable
        readonly
        @close="close"
      />
    </div>
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import PassportForm from './components/LKPassportForm.vue'
import LKRoadmapsFeedModalContainer from '@/views/LKRoadmapsFeed/components/Modals/LKRoadmapsFeedModalContainer.vue'

export default {
  name: 'LKPassportModal',
  components: {
    PassportForm, LKRoadmapsFeedModalContainer,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
  }),
  beforeDestroy() {
    if (this.resolve) this.close()
  },
  methods: {
    open() {
      // ждем подгрузки стилей для анимации модалки
      setTimeout(() => { this.isActive = true }, 300)

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close() {
      this.isActive = false
      this.resolve()
      this.resolve = null
      this.$emit('closed')
      clearInterval(this.intervalId)
      if (this.resetOnClose) this.onReset()
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKPassportModal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  max-height: calc(100% - #{2 * $modal-padding});
  margin: $modal-padding auto;
  overflow: auto;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  & &__title {
    margin-top: 12px;
    font-size: 22px;
  }

  &__line {
    height: 1px;
    margin: 22px 0 30px 0;
    color: $webflow-color-alert-line;
    background-color: $webflow-color-alert-line;
    border: 0;
  }
}
</style>
